var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inbox-in 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.89976 7.74993C7.55916 7.40934 7.55916 6.8588 7.89976 6.51821C8.24036 6.17761 8.79089 6.17761 9.13149 6.51821L11.1289 8.51562V2.41797C11.1289 1.93625 11.5183 1.54688 12 1.54688C12.4817 1.54688 12.8711 1.93625 12.8711 2.41797V8.51562L14.8685 6.51821C15.2091 6.17761 15.7596 6.17761 16.1002 6.51821C16.4408 6.8588 16.4408 7.40934 16.1002 7.74993L13.2317 10.6184C12.8946 10.9556 12.4512 11.1254 12.0078 11.1272L12 11.1289L11.9922 11.1272C11.5488 11.1254 11.1054 10.9556 10.7683 10.6184L7.89976 7.74993ZM19.8398 12H17.2266C16.2657 12 15.4844 12.7814 15.4844 13.7422C15.4844 14.703 14.703 15.4844 13.7422 15.4844H10.2578C9.297 15.4844 8.51562 14.703 8.51562 13.7422C8.51562 12.7814 7.73425 12 6.77344 12H4.16016C2.71937 12 1.54688 13.1725 1.54688 14.6133V18.0977C1.54688 20.4993 3.50074 22.4531 5.90234 22.4531H18.0977C20.4993 22.4531 22.4531 20.4993 22.4531 18.0977V14.6133C22.4531 13.1725 21.2806 12 19.8398 12Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.db8bf6adfc1da306462c38ca5fcb4ff8.svg";
export { ForwardRef as ReactComponent };